import { render } from "./BadRequest.vue?vue&type=template&id=fd87f008"
import script from "./BadRequest.vue?vue&type=script&lang=js"
export * from "./BadRequest.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__